const fallbackLng = 'en'
const languages = [
  fallbackLng,
  'da',
  'tr',
  'th',
  'fr',
  'ru',
  'ja',
  'es',
  'pt',
  'de',
  'zh',
  'ko',
  'vi',
  'ar',
  'hi',
  'en-soc',
  'es-lotobola'
]
const defaultNS = 'common'
const gameRulesNS = 'gameRules'
const gameTracksNS = 'gameTracks'
const marbleColorsNS = 'marbleColors'

export const getI18nSettings = (
  lng = fallbackLng,
  ns: string | string[] = [defaultNS, gameRulesNS, gameTracksNS, marbleColorsNS]
) => ({
  debug: false,
  supportedLngs: languages,
  fallbackLng,
  lng,
  fallbackNS: defaultNS,
  defaultNS,
  ns,
  returnEmptyString: false,
  react: { useSuspense: false },
  lowerCaseLng: true
})

// Variants (see languageVariants.ts) are never offered in the picker, and the picker is hidden while one is active.
export const EXCLUDED_LANGUAGES = ['en-soc', 'es-lotobola']

export const ALLOWED_LANGUAGES: string[] = languages.filter(
  (lng) => !EXCLUDED_LANGUAGES.includes(lng)
)

export const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  da: 'Danish',
  th: 'Thai',
  fr: 'French',
  ru: 'Russian',
  tr: 'Turkish',
  ja: 'Japanese',
  es: 'Spanish',
  pt: 'Portuguese',
  de: 'German',
  zh: 'Chinese',
  ko: 'Korean',
  vi: 'Vietnamese',
  ar: 'Arabic',
  hi: 'Hindi'
}
